
export function invalidFoodExists(schema) {
    try {
        schema.days.forEach(day => {
            day.plans.forEach(plan => {
                plan.foods.forEach(food => {
                    if (!food.isValid()) {
                        throw new Error('invalid food exists');
                    }
                });
            });
        });
    } catch (e) {
        if (e.message === 'invalid food exists') {
            return true;
        }
        throw e;
    }
    return false;
}
